import { h } from 'preact'

function hasChecked(object: any): object is HTMLInputElement {
  return 'checked' in object;
}

const Checkbox = ({ label, onUpdate, qaClasses, checked, disabled }: {
  label?: string | JSX.Element,
  onUpdate: (checked: boolean) => void,
  qaClasses: string,
  checked: boolean,
  disabled?: boolean
}) => {
  return (
    <div class='topic-creator__sidebar--checkbox'>
      <label>
        <input type='checkbox' class={qaClasses} checked={checked} disabled={disabled} onChange={(e: Event) => {
          if (e.target && hasChecked(e.target)) {
            onUpdate(e.target.checked)
          }
        }} />
        {label}
      </label>
    </div>
  )
}

export default Checkbox
